var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGovernanceSpecialists(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 534 394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#232020;}.cls-2{mix-blend-mode:multiply;opacity:.04;}.cls-3{fill:#313b54;}.cls-4{fill:#1a2e35;}.cls-5{fill:#eb7524;}.cls-6{isolation:isolate;}.cls-7{fill:#c2c4c3;}.cls-8{fill:#2ba07f;}.cls-9{fill:#fd802e;}.cls-10{fill:#fff;}.cls-11{fill:#dde9ff;}.cls-12{fill:#fdb42d;}.cls-13{fill:#466eaf;}.cls-14{opacity:.1;}.cls-15{fill:#c9d0d0;}.cls-16{fill:#d5d5fd;}.cls-17{fill:#4c74bf;}.cls-18{fill:#686868;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.48,
    y: 162.04,
    width: 3.43,
    height: 1.71
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.37,163.76h-6.59v-1.71h6.59v1.71ZM172.48,163.76h-6.59v-1.71h6.59v1.71ZM162.59,163.76h-6.59v-1.71h6.59v1.71ZM152.69,163.76h-6.59v-1.71h6.59v1.71ZM142.8,163.76h-6.59v-1.71h6.59v1.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.95 166.33 188.24 166.33 188.24 163.76 185.67 163.76 185.67 162.04 189.95 162.04 189.95 166.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.95,279.78h-1.71v-6.88h1.71v6.88ZM189.95,269.46h-1.71v-6.88h1.71v6.88ZM189.95,259.15h-1.71v-6.88h1.71v6.88ZM189.95,248.84h-1.71v-6.88h1.71v6.88ZM189.95,238.52h-1.71v-6.88h1.71v6.88ZM189.95,228.21h-1.71v-6.88h1.71v6.88ZM189.95,217.9h-1.71v-6.88h1.71v6.88ZM189.95,207.58h-1.71v-6.88h1.71v6.88ZM189.95,197.27h-1.71v-6.88h1.71v6.88ZM189.95,186.96h-1.71v-6.88h1.71v6.88ZM189.95,176.64h-1.71v-6.88h1.71v6.88Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.24,
    y: 283.22,
    width: 1.71,
    height: 3.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M425.88,219.46l4.28-4.7c.24-.26.33-.62.24-.96l-1.43-5.77c-.14-.56-.71-.91-1.28-.76l-2.31.59c-.41.1-.71.44-.78.85l-.68,4.29c-.05.31-.23.58-.5.74l-1.42.84c-.29.17-.48.48-.51.82l-.25,3.14c-.05.59.4,1.11,1,1.13l2.82.13c.31.01.61-.11.82-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M425.1,219.91s-.04,0-.05,0l-2.82-.13c-.32-.01-.6-.15-.81-.39-.21-.24-.31-.54-.28-.86l.25-3.14c.03-.37.24-.71.56-.9l1.42-.84c.24-.14.41-.39.45-.66l.68-4.29c.07-.46.41-.82.86-.94l2.31-.59c.3-.08.61-.03.88.13.27.16.45.41.53.71l1.43,5.77c.09.38,0,.77-.27,1.06l-4.28,4.7c-.22.24-.53.38-.85.38ZM427.95,207.34c-.08,0-.16,0-.23.03l-2.31.59c-.37.09-.64.39-.7.77l-.68,4.29c-.05.34-.26.64-.55.81l-1.42.84c-.26.16-.43.43-.46.74l-.25,3.14c-.02.26.06.51.23.7.17.19.41.31.66.32l2.82.13c.28.01.55-.1.74-.31l4.28-4.7c.21-.23.29-.56.22-.86l-1.43-5.77c-.06-.25-.21-.45-.43-.58-.15-.09-.31-.13-.48-.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "357.74 281.38 357.26 323.2 361.71 377.03 367.77 377.03 375.02 327.37 383.32 277.61 357.74 281.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "367.74 379.59 361.18 382.87 357.91 379.59 361.18 376.31 367.74 376.31 367.74 379.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "400.67 281.09 400.15 305.28 394.17 376.61 388.11 376.45 379.24 328.77 375.2 276.65 400.67 281.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.08 379 394.54 382.45 397.91 379.26 394.72 375.9 388.17 375.73 388.08 379"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M405.59,295.95c.13,3.84.05,8.97-1.57,9.17-.3.04-.59-.1-.86-.23-2.81-1.37-4.81-3.3-7.58-4.61-2.9-1.38-6.2-2.11-9.43-2.61-4.81-.77-9.7-1.23-14.54-1.27-4.16-.04-8.49,1.86-12.42,2.9-1.51.4-2.75,1.51-4,2.37-1.86,1.28-2.67,1.78-2.42-.83.41-4.26.84-8.52,1.37-12.77,1.05-8.48,2.47-16.93,4.88-25.14.92-3.13,1.98-6.23,3.04-9.31,1.29-3.76,2.58-7.52,3.88-11.29,1.61-4.68,4.32-7.97,9.06-9.61,4.1-1.41,9.19-1.8,13.18.18,4.43,2.2,6.54,9.69,8.7,13.7,1.89,3.51,4.27,13.08,4.97,16.86.85,4.55,1.64,9.09,2.25,13.61.69,5.01,1.17,10,1.31,14.96.02.55.13,2.08.19,3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M378.72,233.73c.1.08.21.15.33.19.25.08.53.05.8.02,1.08-.13,2.17-.26,3.25-.38,1.27-.22.86-4.2,3.38-6.22,2.59-2.07,1.42-5.06,1.31-7.71-.03-.74-.07-1.5-.38-2.17-.55-1.17-1.82-1.82-3.06-2.21-3.16-.98-6.76-.74-9.54,1.05-.74.48-2.07.23-2.47,1.02-.62,1.21.53,3.29.7,4.64.26,2.07.52,4.3,1.69,6.04,1.09,1.62,3.17,2.4,3.4,4.35.06.5.21,1.07.58,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379.43,234.08c-.14,0-.28-.01-.41-.06-.14-.04-.26-.12-.37-.21h0c-.32-.28-.53-.77-.61-1.45-.14-1.17-.97-1.9-1.85-2.69-.55-.49-1.11-.99-1.53-1.62-1.15-1.71-1.42-3.84-1.68-5.91l-.02-.18c-.06-.44-.22-.96-.39-1.51-.36-1.15-.73-2.34-.3-3.18.26-.51.86-.62,1.44-.73.38-.07.78-.14,1.06-.33,2.66-1.71,6.26-2.11,9.63-1.06,1.6.5,2.65,1.26,3.12,2.26.33.7.36,1.5.39,2.21.02.57.1,1.18.17,1.76.27,2.15.55,4.38-1.52,6.03-1.39,1.11-1.87,2.81-2.25,4.18-.31,1.09-.55,1.95-1.18,2.06l-3.26.39c-.14.02-.28.03-.43.03ZM378.79,233.65c.09.08.19.14.3.17.24.08.51.05.75.02l3.25-.38c.49-.08.71-.89,1-1.91.39-1.4.88-3.13,2.32-4.29,1.98-1.58,1.71-3.75,1.44-5.84-.07-.59-.15-1.2-.17-1.78-.03-.69-.06-1.46-.37-2.12-.44-.95-1.45-1.67-2.99-2.15-3.31-1.03-6.85-.64-9.45,1.04-.32.21-.73.28-1.14.36-.56.1-1.08.2-1.29.62-.39.77-.02,1.97.31,3.03.18.56.34,1.09.4,1.55l.02.18c.26,2.04.53,4.14,1.65,5.81.41.61.96,1.1,1.5,1.58.91.81,1.77,1.57,1.92,2.82.08.62.26,1.08.54,1.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.79,219.75c.18.83.57,1.68.37,2.51-1.32-.45-2.19-1.8-2.66-3.18-.21-.62-.37-1.28-.31-1.95.05-.66.34-1.32.86-1.7.73-.52,2.03-.32,2.24.63.21.95-.78,2.43-.5,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.76,212.43c.03-1,.41-1.89,1.3-2.49.77-.52,1.66-.95,2.12-1.78.36-.64.42-1.43.78-2.08.65-1.16,2.06-1.51,3.29-1.9,3.08-.99,4.73-2.13,7.99-.86,2.32.9,5.31,1.02,7.46,2.33.9.55,1.66,1.43,2.29,2.41,2.17,3.39,2.69,8.17,1.28,11.71-.32.79-.72,1.52-1.15,2.22-.86,1.4-1.78,3.11-3.3,3.8-.1-.66-.59-1.02-.74-1.67-.11-.47-.07-.95-.05-1.43.09-1.86.66-4.81-1.19-5.73-2.35-1.17-6.76-.11-9.03.87-2,.87-5.38,2.01-7.52,1.08-1.98-.87-3.6-4.34-3.53-6.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "388.17 232.91 409.19 243.75 419.25 218.59 427.05 218.95 420.42 252.04 410.64 257.6 387.96 250.52 388.17 232.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "372.54 233.97 362.99 238.09 346.56 253.03 324.41 252.77 324.6 260.36 351.36 266.88 371.13 247.52 372.54 233.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M324.38,254.34l-4.81-1.5c-.24-.08-.51-.05-.73.07l-5,2.73c-.38.21-.57.65-.46,1.06l.51,1.97c.11.44.52.73.98.7l9.49-.64c.52-.04.91-.49.88-1.01l-.19-2.55c-.03-.39-.29-.71-.66-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M314.8,259.48c-.47,0-.89-.32-1.01-.78l-.51-1.97c-.12-.47.09-.95.51-1.18l5-2.73c.25-.13.54-.16.81-.08l4.81,1.5c.41.13.7.49.73.92l.19,2.55c.02.28-.07.55-.25.76-.18.21-.44.34-.72.36l-9.49.64s-.05,0-.07,0ZM319.3,252.91c-.14,0-.28.03-.4.1l-5,2.73c-.34.18-.51.57-.41.95l.51,1.97c.1.39.47.65.87.62l9.49-.64c.22-.02.43-.12.58-.29.15-.17.22-.39.2-.61l-.19-2.55c-.03-.34-.26-.63-.59-.74l-4.81-1.5c-.08-.03-.16-.04-.25-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M108.29,217.13c-.77-1.47-1.64-4.53-3.89-4.4-.16,0-.35.07-.42.21-.15.33.29.88-.05.98-1.38-.74-2.92-1.2-4.49-1.34-.83-.07-1.89.1-2.11.9-.2.7.4,1.35.96,1.82,1.72,1.43,3.61,2.65,5.62,3.63l-.21.3c1.39-1.25,3.02-1.28,4.59-2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103.05,219.95l.7-.98c-1.97-.98-3.83-2.18-5.53-3.59-.84-.69-1.16-1.33-.99-1.93.24-.84,1.3-1.06,2.22-.98,1.55.14,3.1.59,4.48,1.32.04-.04.03-.12-.02-.33-.05-.19-.11-.4-.02-.58.08-.16.26-.26.51-.28.05,0,.09,0,.14,0,1.83,0,2.75,2.05,3.43,3.56.15.33.29.64.42.9l.05.09-.09.05c-.61.32-1.24.53-1.84.72-.97.32-1.89.62-2.73,1.37l-.71.64ZM99.09,212.67c-.74,0-1.48.22-1.66.84-.14.51.16,1.07.92,1.71,1.71,1.42,3.6,2.64,5.6,3.62l.03.02c.78-.57,1.62-.85,2.44-1.12.56-.18,1.15-.37,1.72-.66-.12-.24-.25-.52-.38-.82-.71-1.57-1.58-3.53-3.36-3.43-.06,0-.27.02-.33.15-.05.11,0,.28.03.44.06.22.13.51-.15.6h-.04s-.04,0-.04,0c-1.36-.73-2.9-1.19-4.44-1.32-.11,0-.23-.02-.34-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M200.24,255.31s2.86.42,2.91.43c1.06.16,5.7-2.18,6.69-2.73.57-.31-3.71-2.47-4.17-2.56-.78-.15-2.61.73-3.47.92l-1.22-1.15-1.84,1.1,1.1,3.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M203.26,255.84s-.08,0-.12,0l-2.98-.44-1.14-4.14,1.98-1.19,1.24,1.17c.28-.07.67-.21,1.08-.35.87-.31,1.84-.66,2.38-.56.38.07,4.21,1.95,4.3,2.55.01.09-.02.16-.1.2-.64.36-5.3,2.75-6.64,2.75ZM200.32,255.21l2.84.42c1.01.15,5.56-2.13,6.63-2.72-.03-.36-3.6-2.26-4.14-2.36-.48-.09-1.48.26-2.27.55-.44.16-.86.31-1.15.37h-.05s-1.2-1.12-1.2-1.12l-1.71,1.02,1.06,3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.94,375.16l-.25,1.95c-.09.74.24,1.46.85,1.88l3.71,2.49c.7.47,1.62.44,2.29-.08l.88-.68c.86-.66,1.02-1.89.35-2.75l-1.35-1.75c-.13-.17-.28-.31-.46-.43l-2.99-2.01c-1.21-.81-2.85-.07-3.04,1.38h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "128.74 374.11 133.28 333.96 127.82 289.02 129.05 279.46 153.46 278.53 154.34 294.09 150.24 334.02 134.82 376.16 128.74 374.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.89,376.29l-6.26-2.11v-.08s4.55-40.13,4.55-40.13l-5.47-44.94h0s1.24-9.66,1.24-9.66l24.61-.93v.1s.89,15.56.89,15.56l-4.1,39.96h0s-15.46,42.25-15.46,42.25ZM128.85,374.03l5.91,1.99,15.38-42.03,4.1-39.92-.88-15.44-24.22.92-1.22,9.46,5.47,44.94h0s-4.53,40.07-4.53,40.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "157.35 234.98 168.32 241.43 177.03 253.63 200.22 250.27 200.94 256.66 174.6 265.44 161.11 260.39 157.35 234.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "171.38 283.03 171.44 323.54 163.29 375.69 157.42 375.64 154.19 327.41 146.64 279.13 171.38 283.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.38,375.8l-6.06-.06v-.1s-3.23-48.23-3.23-48.23l-7.57-48.41,24.97,3.93v.09s.06,40.51.06,40.51l-8.17,52.26ZM157.51,375.53l5.68.06,8.14-52.06-.07-40.41-24.51-3.86,7.53,48.13,3.22,48.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.17,378.13l3.98,2.04c.75.39,1.66.25,2.27-.34l.79-.78c.77-.76.79-2,.03-2.77l-1.2-1.22c-.36-.37-.86-.58-1.38-.59l-3.57-.04c-1.08-.01-1.97.86-1.98,1.94h0c0,.74.41,1.43,1.07,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M125.29,296.81c.06-1.76.15-3.22.17-3.74.13-4.71.55-9.41,1.13-14.08.53-4.19,1.2-14.59,1.91-18.76.59-3.44,2.66-12.02,4.15-15.21,3.71-7.93,2.56-8.66,18.85-11.02,7.14-1.03,8.82,3.42,14.66,8.53.58.5.54,3.51.68,4.3.24,1.4.49,2.8.78,4.19.23,1.09.48,2.18.76,3.27h0s4.9,22.29,8.14,27.03c3.24,4.73,9.93,11.35-1.26,15.39-1.98.64-3.98,1.25-6.05,1.58,0,0-9.16-1.02-13.86-.98-4.34.03-8.69.47-12.95,1.21-2.85.48-5.76,1.17-8.31,2.5-2.43,1.27-4.19,3.14-6.66,4.46-.23.12-.49.25-.76.22-1.42-.2-1.48-5.18-1.37-8.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M150.04,236.05c-.67.63-2.48,1.34-4.64,1.17-.44-.03-.82-.33-.94-.75-.35-1.18-.61-2.38-.8-3.6-1.61-.06-3.52-.31-4.24-1.75-.23-.45-.29-.97-.36-1.47-.27-2.08-.53-4.15-.8-6.23-.09-.72-.18-1.46,0-2.16.34-1.23,1.46-2.06,2.59-2.64,2.89-1.47,6.42-1.83,9.41-.56.79.34,1.56.8,2.08,1.5.8,1.07.88,2.49.94,3.82.05,1.23.1,2.46.15,3.68.06,1.41.02,3.05-1.09,3.93-.59.47-1.4.63-1.89,1.2-.86,1.01-.23,2.55-.43,3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.04,237.35c-.21,0-.43,0-.66-.02-.48-.04-.9-.37-1.03-.82-.34-1.15-.6-2.34-.79-3.52-1.61-.07-3.51-.35-4.24-1.81-.24-.47-.3-1-.37-1.5l-.8-6.23c-.09-.69-.19-1.47.01-2.2.29-1.05,1.18-1.96,2.65-2.7,3.09-1.57,6.64-1.78,9.5-.56.97.41,1.66.91,2.12,1.53.84,1.13.91,2.65.96,3.87l.15,3.68c.06,1.57-.03,3.14-1.13,4.01-.26.2-.55.35-.84.49-.39.2-.77.38-1.03.7-.52.61-.46,1.44-.4,2.31.03.5.07,1.01,0,1.5v.04s-.03.02-.03.02c-.56.52-2.05,1.23-4.06,1.23ZM146.33,217.4c-1.81,0-3.68.45-5.41,1.32-1.42.72-2.27,1.58-2.54,2.57-.19.69-.09,1.45,0,2.12l.8,6.23c.06.49.13.99.35,1.44.69,1.38,2.58,1.63,4.15,1.69h.09s.01.09.01.09c.18,1.21.45,2.41.79,3.58.11.37.45.64.85.67,1.99.15,3.81-.46,4.54-1.12.07-.45.03-.94,0-1.41-.06-.88-.12-1.78.45-2.46.3-.35.71-.55,1.1-.75.28-.14.56-.28.8-.47,1.03-.81,1.11-2.33,1.05-3.84l-.15-3.68c-.05-1.19-.11-2.68-.92-3.76-.44-.59-1.1-1.06-2.03-1.46-1.21-.51-2.54-.77-3.91-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.62,210.95c.15-.58.33-1.16.55-1.72.49-1.21,1.2-2.33,1.5-3.6.3-1.27.08-2.79-.98-3.54-.68-.49-1.57-.56-2.41-.55-2.77.03-5.52.82-7.88,2.26-2.25,1.37-4.12,3.07-6.86,2.91-2.57-.15-4.13.71-6.28,2.31-2.32,1.73-5.76,3.03-7.72,5.07-.82.85-1.34,1.95-1.66,3.09-1.12,3.94.26,8.47,3.38,11.12.7.59,1.47,1.1,2.27,1.56,1.64.96,3.62,2.15,5.47,2.13-.43-1.53-3.28-5.88-2.49-7.48,1.24-2.54,5.63-3.14,8.07-3.35,2.66-.24,5.43.85,8.03.46,1.87-.28,3.87-1.85,5.11-3.24,1.52-1.71,1.37-5.3,1.92-7.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "137.25 237.48 124.44 240.77 109.01 216.79 102.5 218.55 113.36 253.07 138.33 256.08 137.25 237.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M358.18,290.06c-1.11,0-2.22.04-3.31.11-3.7-21.34-22.43-37.58-44.98-37.58-10.31,0-19.83,3.4-27.47,9.13-8.26-14.47-23.91-24.23-41.85-24.23-26.55,0-48.08,21.38-48.08,47.74,0,1.67.09,3.32.26,4.95-1.09-.07-2.19-.11-3.3-.11-26.55,0-48.08,21.38-48.08,47.74s21.52,47.74,48.08,47.74h168.73c26.55,0,48.08-21.38,48.08-47.74s-21.52-47.74-48.08-47.74Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "234.5 129.84 206.93 129.53 209.66 108.47 232.24 108.72 234.5 129.84"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 148.24,
    y: 8.62,
    width: 145.18,
    height: 105.68,
    rx: 1.7,
    ry: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M148.24,10.69v90.53h145.18V10.69c0-1.23-1-2.23-2.23-2.23h-140.71c-1.23,0-2.23,1-2.23,2.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 152.07,
    y: 12.7,
    width: 137.53,
    height: 83.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 199.05,
    y: 126.94,
    width: 43.56,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 445.25,
    y: 118.44,
    width: 59.89,
    height: 103.83,
    rx: 4.32,
    ry: 4.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 449.69,
    y: 123.84,
    width: 51.01,
    height: 84.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 468.49,
    y: 213.68,
    width: 13.41,
    height: 4.4,
    rx: 1.74,
    ry: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 333,
    y: 52.96,
    width: 78.53,
    height: 116.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M411.53,169.32h-78.53c-.15,0-.26-.12-.26-.26V52.96c0-.15.12-.26.26-.26h78.53c.15,0,.26.12.26.26v116.1c0,.15-.12.26-.26.26ZM333.26,168.79h78V53.22h-78v115.57Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "411.53 52.96 334.89 179.8 411.53 179.8 411.53 52.96"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 330.25,
    y: 52.96,
    width: 84.34,
    height: 22.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 338.6,
    y: 63.55,
    width: 41,
    height: 1.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 392.19,
    y: 62.41,
    width: 3.96,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 400.66,
    y: 62.41,
    width: 3.96,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 330.25,
    y: 78.95,
    width: 84.34,
    height: 22.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 338.6,
    y: 89.54,
    width: 41,
    height: 1.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 392.19,
    y: 88.4,
    width: 3.96,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 400.66,
    y: 88.4,
    width: 3.96,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 330.25,
    y: 104.95,
    width: 84.34,
    height: 22.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 338.6,
    y: 115.54,
    width: 41,
    height: 1.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 392.19,
    y: 114.4,
    width: 3.96,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 400.66,
    y: 114.4,
    width: 3.96,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 330.25,
    y: 130.94,
    width: 84.34,
    height: 22.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 338.6,
    y: 141.53,
    width: 41,
    height: 1.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 392.19,
    y: 140.39,
    width: 3.96,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 400.66,
    y: 140.39,
    width: 3.96,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 330.25,
    y: 156.94,
    width: 84.34,
    height: 22.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 338.6,
    y: 167.53,
    width: 41,
    height: 1.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 392.19,
    y: 166.39,
    width: 3.96,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 400.66,
    y: 166.39,
    width: 3.96,
    height: 3.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.73,122.44v-1.29c.01-2.1-1.73-3.81-3.88-3.82l-40.73-.17c-2.16,0-3.91,1.69-3.92,3.79l-.28,68.62,97.07.4.26-63.52c0-2.1-1.73-3.81-3.89-3.82l-44.63-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.99,190.24h0l-97.07-.4c-.07,0-.14-.03-.19-.08s-.08-.12-.08-.19l.28-68.62c0-1.09.44-2.11,1.24-2.87.79-.76,1.83-1.18,2.93-1.18h.02l40.73.17c1.11,0,2.16.43,2.94,1.2.79.77,1.22,1.8,1.21,2.89v1.03s44.36.18,44.36.18c1.11,0,2.16.43,2.94,1.2.79.77,1.22,1.8,1.21,2.89l-.26,63.52c0,.15-.12.26-.26.26ZM28.18,189.31l96.55.4.26-63.26c0-.94-.37-1.83-1.05-2.51-.69-.67-1.6-1.05-2.57-1.05l-44.63-.19c-.15,0-.26-.12-.26-.26v-1.29c0-.94-.36-1.83-1.05-2.51-.69-.67-1.6-1.05-2.57-1.05l-40.73-.17h-.02c-.97,0-1.88.37-2.57,1.03-.69.67-1.07,1.55-1.07,2.5l-.28,68.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 32.35,
    y: 127.93,
    width: 89.36,
    height: 62.54,
    transform: "translate(.66 -.32) rotate(.24)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.89,134.07l-1.46,3.89-40.4-.17c-2.16,0-3.91,1.69-3.92,3.79l-.2,48.45c0,2.1,1.73,3.81,3.89,3.82l89.26.37c2.16,0,3.91-1.69,3.92-3.79l.23-54.86c0-2.1-1.73-3.81-3.89-3.82l-43.75-.18c-1.65,0-3.12.99-3.68,2.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M75.29,135.74l-1.46,3.89-41.81-.17c-2.16,0-3.91,1.69-3.92,3.79l-.2,48.45c0,2.1,1.73,3.81,3.89,3.82l89.26.37c2.16,0,3.91-1.69,3.92-3.79l.23-54.86c0-2.1-1.73-3.81-3.89-3.82l-42.34-.18c-1.65,0-3.12.99-3.68,2.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.68,
    y: 139.73,
    width: 1.71,
    height: 3.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.39,231.4h-1.71v-6.54h1.71v6.54ZM221.39,221.59h-1.71v-6.54h1.71v6.54ZM221.39,211.79h-1.71v-6.54h1.71v6.54ZM221.39,201.98h-1.71v-6.54h1.71v6.54ZM221.39,192.18h-1.71v-6.54h1.71v6.54ZM221.39,182.38h-1.71v-6.54h1.71v6.54ZM221.39,172.57h-1.71v-6.54h1.71v6.54ZM221.39,162.77h-1.71v-6.54h1.71v6.54ZM221.39,152.96h-1.71v-6.54h1.71v6.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.68,
    y: 234.66,
    width: 1.71,
    height: 3.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.16,238.27c-.06-.26-.13-.91-.17-3.58l1.71-.03c.05,2.64.12,3.16.14,3.26l-1.68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.95,231.45c-.01-1.69-.02-3.63-.02-5.77v-.69s1.71,0,1.71,0v.69c0,2.13,0,4.07.02,5.76h-1.71ZM265.65,221.77h-1.71c0-2.05.01-4.22.03-6.46h1.71c-.01,2.25-.02,4.41-.03,6.46ZM265.7,212.1h-1.71c.01-2.13.03-4.29.05-6.46h1.71c-.02,2.18-.03,4.35-.05,6.46ZM265.77,202.42h-1.71s.06-6.47.06-6.47l1.71.02-.06,6.45ZM265.86,192.74l-1.71-.02c.02-2.24.05-4.41.07-6.45l1.71.02c-.02,2.05-.05,4.21-.07,6.45ZM265.97,183.06l-1.71-.02.08-6.46,1.71.02-.08,6.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.08 173.43 264.37 173.4 264.43 169.13 268.7 169.13 268.7 170.84 266.12 170.84 266.08 173.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.55,170.84h-6.25v-1.71h6.25v1.71ZM306.18,170.84h-6.25v-1.71h6.25v1.71ZM296.81,170.84h-6.25v-1.71h6.25v1.71ZM287.44,170.84h-6.25v-1.71h6.25v1.71ZM278.07,170.84h-6.25v-1.71h6.25v1.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.67,
    y: 169.13,
    width: 3.43,
    height: 1.71
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.59,
    y: 243.31,
    width: 1.71,
    height: 3.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.3,240h-1.71v-6.63h1.71v6.63ZM306.3,230.05h-1.71v-6.63h1.71v6.63ZM306.3,220.11h-1.71v-6.63h1.71v6.63ZM306.3,210.16h-1.71v-6.63h1.71v6.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.3 200.21 304.59 200.21 304.59 195.93 308.87 195.93 308.87 197.64 306.3 197.64 306.3 200.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.53,197.64h-6.87v-1.71h6.87v1.71ZM422.22,197.64h-6.87v-1.71h6.87v1.71ZM411.92,197.64h-6.87v-1.71h6.87v1.71ZM401.61,197.64h-6.87v-1.71h6.87v1.71ZM391.31,197.64h-6.87v-1.71h6.87v1.71ZM381,197.64h-6.87v-1.71h6.87v1.71ZM370.7,197.64h-6.87v-1.71h6.87v1.71ZM360.4,197.64h-6.87v-1.71h6.87v1.71ZM350.09,197.64h-6.87v-1.71h6.87v1.71ZM339.79,197.64h-6.87v-1.71h6.87v1.71ZM329.48,197.64h-6.87v-1.71h6.87v1.71ZM319.18,197.64h-6.87v-1.71h6.87v1.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.96,
    y: 195.93,
    width: 3.43,
    height: 1.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M262.3,299.89v11.31l20.18-20.18-20.18-20.18v11.74c-2.71.57-5.35,1.41-7.84,2.53-2.01.89-3.93,1.93-5.74,3.12-1.8,1.2-3.49,2.53-5.06,3.98-3.13,2.89-5.7,6.28-7.66,9.92-1.97,3.64-3.25,7.58-3.9,11.54-.61,3.98-.58,7.97.1,11.8.69,3.83,1.99,7.48,3.8,10.78,1.85,3.29,4.21,6.2,6.9,8.64,2.73,2.42,5.79,4.34,9.02,5.72-2.86-2.05-5.34-4.51-7.33-7.26-1.96-2.77-3.45-5.79-4.4-8.91-.92-3.14-1.3-6.35-1.17-9.49.13-3.15.82-6.2,1.91-9,1.14-2.79,2.67-5.35,4.58-7.53,1.91-2.18,4.11-4.02,6.53-5.39,1.2-.69,2.45-1.27,3.71-1.75,1.27-.47,2.57-.82,3.86-1.06.89-.17,1.78-.28,2.67-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M307.34,316.17c-.69-3.83-1.99-7.48-3.8-10.78-1.85-3.29-4.21-6.2-6.9-8.64-2.73-2.42-5.79-4.34-9.02-5.72,2.86,2.05,5.34,4.51,7.33,7.26,1.96,2.77,3.45,5.79,4.4,8.91.92,3.14,1.3,6.35,1.17,9.49-.13,3.15-.82,6.2-1.91,9-1.14,2.79-2.67,5.35-4.58,7.53-1.91,2.18-4.11,4.02-6.53,5.39-1.2.69-2.45,1.27-3.71,1.75-1.27.47-2.57.82-3.86,1.06-.89.17-1.78.28-2.67.34v-11.31l-20.18,20.18,20.18,20.18v-11.74c2.71-.57,5.35-1.41,7.84-2.53,2.01-.89,3.93-1.93,5.74-3.12,1.8-1.2,3.49-2.53,5.06-3.98,3.13-2.89,5.7-6.28,7.66-9.92,1.97-3.64,3.25-7.58,3.9-11.54.61-3.98.58-7.97-.1-11.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernanceSpecialists);
export default __webpack_public_path__ + "static/media/governance-specialists.7499161cacb2a39658650ec6e304381b.svg";
export { ForwardRef as ReactComponent };